import { Icon, Icons } from 'components/Icon';
import React from 'react';

type Props = {
  onSelect: (value: string) => void;
  selectedIdentity: string;
  fieldValue: string;
  fieldTitle: string;
  fieldIcon: Icons;
};

export default function IdentificationCard({
  onSelect,
  selectedIdentity,
  fieldValue,
  fieldTitle,
  fieldIcon
}: Props) {
  return (
    <div
      className={`w-[9rem] rounded-lg border border-[#3E3E3E80] ${
        selectedIdentity === fieldValue ? 'bg-primary-900' : ''
      }`}
      tabIndex={-1}
      role="button"
      onClick={() => onSelect(fieldValue)}
    >
      <div className="flex flex-col items-center gap-10 py-4">
        <div>
          <Icon
            name={fieldIcon}
            fill={selectedIdentity === fieldValue ? '#FFFFFF' : '#FF6606'}
          />
        </div>
        <div className="px-5">
          <h5
            className={`text-center text-lg font-bold tracking-tight ${
              selectedIdentity === fieldValue ? 'text-white' : 'text-[#525F7F]'
            }`}
          >
            {fieldTitle}
          </h5>
        </div>
      </div>
    </div>
  );
}
